import React from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import SydModal from '../../../../commonDesign/SydModal'
import SydModalActions from '../../../../commonDesign/SydModal/SydModalActions'
import SydButton from '../../../../commonDesign/Button'
import Markup from '../../../../atoms/Markup'
import { labelStyle, valueStyle as baseValueStyle } from '../shared/redtailUIHelpers'

const valueStyle = { ...baseValueStyle, marginBottom: '12px' }

function formatDate (isoString) {
  if (!isoString) return null
  return dayjs(isoString).format('ddd, MMM D, YYYY h:mma')
}

function NoteDetailModal ({ open, onClose, note }) {
  if (!note) return null

  const category = note.category || note.note_type_description || null
  const createdAt = formatDate(note.created_at)

  return (
    <SydModal
      open={open}
      onClose={onClose}
      title={category || 'Note'}
      subtitle={createdAt}
      size='medium'
      disablePortal={false}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {note._contact_name ? (
          <>
            <div style={labelStyle}>Contact</div>
            <div style={valueStyle}>{note._contact_name}</div>
          </>
        ) : null}

        {note.body ? (
          <>
            <div style={labelStyle}>Content</div>
            <div style={valueStyle}>
              <Markup value={note.body} type='html' style={{ fontSize: 'inherit' }} />
            </div>
          </>
        ) : (
          <div style={{ ...valueStyle, color: 'var(--text-color-subtle)', fontStyle: 'italic' }}>
            No content
          </div>
        )}
      </div>

      <SydModalActions>
        <SydButton variant='ghost' size='sm' onClick={onClose}>
          Close
        </SydButton>
      </SydModalActions>
    </SydModal>
  )
}

NoteDetailModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  note: PropTypes.object
}

export default NoteDetailModal
